<template>
  <formsTemplate>
    <p class="font-weight-bold text-body-1 text-center">
      {{ $t("loginView.doLogin") }}
    </p>
    <p class="text-body-1 text-center mt-2 mb-10">
      {{ $t("loginView.btreeAccount") }}
    </p>
    <div v-if="isLogged">
      <v-card
        class="py-2 d-flex align-center rounded justify-center pl-5"
        :class="{ 'mx-5': !$vuetify.breakpoint.mobile }"
        v-if="loading"
      >
        <div class="relative" style="width: 52px; height: 52px">
          <v-progress-circular
            value="100"
            class="absolute"
            color="black"
            size="50"
            width="7"
          ></v-progress-circular>
          <v-progress-circular
            indeterminate
            class="absolute"
            color="primary"
            size="50"
            width="7"
          ></v-progress-circular>
        </div>
      </v-card>
      <v-card
        class="py-2 d-flex align-center rounded pl-5"
        :class="{ 'mx-5': !$vuetify.breakpoint.mobile }"
        v-else
        @click="redirectTo(urlRedi)"
      >
        <v-avatar size="50" color="white">
          <img class="rounded-circle" :src="image" alt="" v-if="image" />
          <v-icon size="40" v-else color="primary">$user</v-icon>
        </v-avatar>
        <div class="ml-6">
          <p
            class="font-weight-bold text-h6"
            :class="{ 'text-body-1': $vuetify.breakpoint.mobile }"
          >
            {{ name }}
          </p>
          <p
            class="font-weight-regular text-caption"
          >
            {{ hideEmail(email) }}
          </p>
        </div>
      </v-card>
      <p
        class="mt-6 text-center"
        :class="{ 'text-body-2': $vuetify.breakpoint.mobile }"
      >
        {{ $t("loginView.changeAccount") }}
        <a @click="clean">{{ $t("loginView.changeAccount2") }}</a>
      </p>
    </div>
    <v-form v-else ref="form" v-model="valid" lazy-validation>
      <p class="font-weight-bold text-body-1">{{ $t("loginView.email") }}</p>
      <v-text-field
        solo
        v-model="userEmail"
        hide-details="auto"
        @keydown.enter="logar"
        :rules="[rules.required, rules.email]"
        flat
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
      </v-text-field>
      <p class="font-weight-bold text-body-1 mt-6">
        {{ $t("loginView.password") }}
      </p>
      <v-text-field
        v-model="senha"
        solo
        hide-details="auto"
        :rules="[rules.required]"
        flat
        @keydown.enter="logar"
        :type="show ? 'text' : 'password'"
      >
        <template v-slot:message="{ message }">
          {{ $t(message) }}
        </template>
        <template slot="append">
          <a @click="show = !show">
            <v-icon>{{ show ? "$eye-off" : "$eye" }}</v-icon>
          </a>
        </template>
      </v-text-field>
      <p class="text-body-1 mt-2">
        <router-link :to="{ name: 'recovery', query: $route.query }">{{
          $t("loginView.forgotPassword")
        }}</router-link>
      </p>
      <div class="d-flex justify-space-between mt-6">
        <v-btn
          color="secondary"
          class="primary--text"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :to="{ name: 'register', query: $route.query }"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("loginView.textRegister") }}
          </p>
        </v-btn>
        <v-btn
          color="success"
          :height="$vuetify.breakpoint.mobile ? 36 : 40"
          :width="$vuetify.breakpoint.mobile ? 144 : 160"
          elevation="0"
          :loading="loading"
          @click="logar"
        >
          <p class="font-weight-bold text-body-1 text-capitalize">
            {{ $t("loginView.login") }}
          </p>
        </v-btn>
      </div>
    </v-form>
  </formsTemplate>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useAuthStore } from "@/stores/auth";
import { rules } from "@/mixins/rules";
import formsTemplate from "@/components/formsTemplate.vue";
export default {
  components: {
    formsTemplate,
  },
  created() {
    if (this.isLogged) {
      this.validLogin();
    }
  },
  data: () => ({
    show: false,
    userEmail: "",
    senha: "",
    rules,
    valid: false,
  }),
  computed: {
    ...mapState(useAuthStore, [
      "loading",
      "isLogged",
      "name",
      "email",
      "image",
    ]),
    csrf() {
      return this.$route.query?.csrf || "";
    },
    urlRedi() {
      return this.$route.query?.url_retorno || "bauth";
    },
  },
  methods: {
    ...mapActions(useAuthStore, [
      "redirectTo",
      "login",
      "clean",
      "gerarCSRF",
      "setCSRF",
      "validLogin",
    ]),
  hideEmail(value) {
      if (!value) return '';
      const dividerEmail = value.split('@');
      let email="";
      email = dividerEmail[0].substring(0, 3);
      const stars =  dividerEmail[0].substring(4).length>0?'***':''
      email = email + stars;
      return email + '@' + dividerEmail[1];
    },
    async logar() {
      await this.$refs.form.validate();
      if (this.valid) {
        let isCsrf = true;
        if (!this.csrf) {
          isCsrf = await this.gerarCSRF();
        } else {
          this.setCSRF(this.csrf);
        }

        if (isCsrf) {
          await this.login(this.userEmail, this.senha);
        }
      }
    },
  },
};
</script>
<style scoped>
.m-auto {
  margin-left: auto;
  margin-right: auto;
}
::v-deep .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #252831;
}
</style>
